<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div class="section-title xtium-title">{{ $t('licensingSummary.licensing') }}</div>
    <div class="licensing-cards-container">
      <EcsLicensingCard
        class="licensing-card-item my-2 mr-4"
        v-for="card in items"
        :key="card.title"
        :label="$t(card.title)"
        :value="card.value"
        :icon="card.icon"
        :is-loading="isLoading"
      />
    </div>
  </div>
</template>

<script>
import EcsLicensingCard from '@/components/ecs-summary-view/EcsLicensingCard';

export default {
  name: 'EcsLicensingSummary',
  components: { EcsLicensingCard },
  props: {
    concurrentAgents: {
      type: Number,
      required: true
    },
    concurrentSupervisors: {
      type: Number,
      required: true
    },
    concurrentWallboards: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    items() {
      return [
        {
          title: 'licensingSummary.agents',
          value: this.concurrentAgents || 0,
          icon: 'mdi-account'
        },
        {
          title: 'licensingSummary.supervisors',
          value: this.concurrentSupervisors || 0,
          icon: 'mdi-account-supervisor'
        },
        {
          title: 'licensingSummary.wallboards',
          value: this.concurrentWallboards || 0,
          icon: 'mdi-view-dashboard'
        }
      ];
    }
  }
};
</script>

<style scoped>
.section-title {
  color: var(--v-primary-base);
  text-transform: uppercase;
}
.licensing-cards-container {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  overflow: auto;
}
</style>
